import { MailboxInfo, MailboxType } from 'owa-client-ids';
import saveAttachmentsToCloudRequest from 'owa-service/lib/factory/saveAttachmentsToCloudRequest';
import saveAttachmentsToCloudOperation from 'owa-service/lib/operation/saveAttachmentsToCloudOperation';

function createRequestBody(
    attachmentId: string,
    itemId: string,
    subscriptionId: string,
    channelId: string,
    groupSmtpAddress: string
) {
    return saveAttachmentsToCloudRequest({
        ewsAttachmentId: attachmentId,
        itemId: itemId,
        subscriptionId: subscriptionId,
        groupSmtpAddress: groupSmtpAddress,
        channelId: channelId,
    });
}

export default function saveAttachmentsToCloud(
    attachmentId: string,
    itemId: string,
    subscriptionId: string,
    channelId: string,
    mailboxInfo: MailboxInfo
): Promise<string> {
    const groupMailboxSmtp =
        mailboxInfo.type === MailboxType.GroupMailbox ? mailboxInfo.mailboxId : null;

    const requestBody = createRequestBody(
        attachmentId,
        itemId,
        subscriptionId,
        channelId,
        groupMailboxSmtp
    );

    return saveAttachmentsToCloudOperation(
        {
            requestObject: requestBody,
        },
        mailboxInfo.requestOptions
    );
}
